import { useQuery } from '@tanstack/react-query';
import { Feature, MultiPolygon, Polygon } from 'geojson';
import { API } from 'api';

export type EvacZoneGeometry = Feature<
  Polygon | MultiPolygon,
  { uidV2: string }
>;

type UseEvacZoneGeometryProps = {
  uid: string;
  enabled?: boolean;
};

const fetchEvacZoneGeometry = async (
  uid: string,
): Promise<EvacZoneGeometry> => {
  const { data } = await API.get<EvacZoneGeometry>(
    `evac_zones/geometries/${encodeURIComponent(uid)}`,
  );
  return data;
};

// Simplified for low zooms, where the tiles don't include zones without a status.
export const useEvacZoneGeometry = ({
  uid,
  enabled = true,
}: UseEvacZoneGeometryProps): EvacZoneGeometry | undefined => {
  const { data } = useQuery({
    queryKey: ['evac-zone-geometry', uid],
    queryFn: () => fetchEvacZoneGeometry(uid),
    enabled: Boolean(uid) && enabled,
    staleTime: 1000 * 60 * 15, // 15 minutes
  });
  return data;
};
